var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9804764%",
    y1: "-1.64142327e-09%",
    x2: "49.9804764%",
    y2: "99.9584537%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A7A7A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.2517888%",
    cy: "67.5814637%",
    fx: "49.2517888%",
    fy: "67.5814637%",
    r: "62.3374355%",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B6B6B",
    offset: "65.3161473%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9983094%",
    y1: "-0.0252747253%",
    x2: "49.9983094%",
    y2: "100.005495%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC",
    offset: "21.82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4",
    offset: "35.38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5",
    offset: "46.71%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D1D1",
    offset: "56.79%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6B6",
    offset: "66.05%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#959595",
    offset: "74.72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E6E6E",
    offset: "82.92%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414141",
    offset: "90.75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F",
    offset: "98.03%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9996616%",
    y1: "0.120873786%",
    x2: "49.9996616%",
    y2: "99.9021845%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7",
    offset: "0.587422%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3D3",
    offset: "3.627752%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B2B2",
    offset: "7.048631%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#979797",
    offset: "10.83%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818181",
    offset: "15.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#707070",
    offset: "20.09%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#646464",
    offset: "26.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5E5E",
    offset: "34.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C5C5C",
    offset: "58.92%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9979902%",
    y1: "0.00701394586%",
    x2: "49.9979902%",
    y2: "99.990361%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666",
    offset: "27.57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "31.35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#404040",
    offset: "62.16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838",
    offset: "94.05%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M220.737743,0 L34.2661479,0 C15.3400778,0 0,15.3400778 0,34.2661479 L0,220.837354 C0,239.763424 15.3400778,255.103502 34.2661479,255.103502 L220.837354,255.103502 C239.763424,255.103502 255.103502,239.763424 255.103502,220.837354 L255.103502,34.2661479 C255.003891,15.3400778 239.663813,0 220.737743,0 L220.737743,0 L220.737743,0 Z",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.940856,1.09571984 L34.9634241,1.09571984 C16.2365759,1.09571984 1.09571984,16.2365759 1.09571984,34.9634241 L1.09571984,219.940856 C1.09571984,238.667704 16.3361868,253.908171 35.063035,253.908171 L220.040467,253.908171 C238.767315,253.908171 254.007782,238.667704 254.007782,219.940856 L254.007782,34.9634241 C253.908171,16.2365759 238.767315,1.09571984 219.940856,1.09571984 L219.940856,1.09571984 L219.940856,1.09571984 Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.245914,215.259144 C244.245914,232.59144 230.200778,246.536965 212.968093,246.536965 L42.3346304,246.536965 C25.0023346,246.536965 11.0568093,232.491829 11.0568093,215.259144 L11.0568093,44.7252918 C11.0568093,27.3929961 25.1019455,13.4474708 42.3346304,13.4474708 L212.868482,13.4474708 C230.200778,13.4474708 244.146304,27.492607 244.146304,44.7252918 L244.146304,215.259144 L244.245914,215.259144 L244.245914,215.259144 Z",
    opacity: 0.3,
    fill: "url(#radialGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.66537,9.56264591 L41.3385214,9.56264591 C23.8070039,9.56264591 9.66225681,23.707393 9.66225681,41.1392996 L9.66225681,103.49572 C43.8287938,112.859144 84.1712062,118.337743 127.501946,118.337743 C170.733074,118.337743 211.175097,112.859144 245.341634,103.49572 L245.341634,41.1392996 C245.341634,23.707393 231.196887,9.56264591 213.66537,9.56264591 L213.66537,9.56264591 L213.66537,9.56264591 Z",
    opacity: 0.3,
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3385214,18.8264591 L213.66537,18.8264591 C231.097276,18.8264591 245.242023,32.9712062 245.242023,50.4031128 L245.242023,41.0396887 C245.242023,23.6077821 231.097276,9.46303502 213.66537,9.46303502 L41.3385214,9.46303502 C23.9066148,9.46303502 9.7618677,23.707393 9.7618677,41.1392996 L9.7618677,50.5027237 C9.7618677,32.9712062 23.9066148,18.8264591 41.3385214,18.8264591 L41.3385214,18.8264591 L41.3385214,18.8264591 Z",
    opacity: 0.64,
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5455253,248.927626 C21.0178988,248.927626 6.07626459,233.985992 6.07626459,215.458366 L6.07626459,215.458366 L6.07626459,39.5455253 C6.07626459,21.0178988 21.0178988,6.07626459 39.5455253,6.07626459 L39.5455253,6.07626459 L215.458366,6.07626459 C233.985992,6.07626459 248.927626,21.0178988 248.927626,39.5455253 L248.927626,39.5455253 L248.927626,215.458366 C248.927626,233.985992 233.985992,248.927626 215.458366,248.927626 L215.458366,248.927626 L39.5455253,248.927626 L39.5455253,248.927626 Z M8.46692607,39.5455253 L8.46692607,215.458366 C8.46692607,232.59144 22.4124514,246.536965 39.5455253,246.536965 L39.5455253,246.536965 L215.458366,246.536965 C232.59144,246.536965 246.536965,232.59144 246.536965,215.458366 L246.536965,215.458366 L246.536965,39.5455253 C246.536965,22.4124514 232.59144,8.46692607 215.458366,8.46692607 L215.458366,8.46692607 L39.5455253,8.46692607 C22.4124514,8.46692607 8.46692607,22.4124514 8.46692607,39.5455253 L8.46692607,39.5455253 L8.46692607,39.5455253 Z",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.458366,249.525292 L39.5455253,249.525292 C20.7190661,249.525292 5.47859922,234.185214 5.47859922,215.458366 L5.47859922,39.5455253 C5.47859922,20.7190661 20.818677,5.47859922 39.5455253,5.47859922 L215.458366,5.47859922 C234.284825,5.47859922 249.525292,20.818677 249.525292,39.5455253 L249.525292,215.458366 C249.525292,234.284825 234.284825,249.525292 215.458366,249.525292 L215.458366,249.525292 L215.458366,249.525292 Z M39.5455253,6.67392996 C21.4163424,6.67392996 6.67392996,21.4163424 6.67392996,39.5455253 L6.67392996,215.458366 C6.67392996,233.587549 21.4163424,248.329961 39.5455253,248.329961 L215.458366,248.329961 C233.587549,248.329961 248.329961,233.587549 248.329961,215.458366 L248.329961,39.5455253 C248.329961,21.4163424 233.587549,6.67392996 215.458366,6.67392996 L39.5455253,6.67392996 L39.5455253,6.67392996 Z M215.458366,247.13463 L39.5455253,247.13463 C22.1136187,247.13463 7.8692607,232.890272 7.8692607,215.458366 L7.8692607,39.5455253 C7.8692607,22.1136187 22.1136187,7.8692607 39.5455253,7.8692607 L215.458366,7.8692607 C232.890272,7.8692607 247.13463,22.1136187 247.13463,39.5455253 L247.13463,215.458366 C247.13463,232.890272 232.890272,247.13463 215.458366,247.13463 L215.458366,247.13463 L215.458366,247.13463 Z M9.06459144,39.5455253 L9.06459144,215.458366 C9.06459144,232.192996 22.711284,245.839689 39.5455253,245.9393 L215.458366,245.9393 C232.192996,245.9393 245.9393,232.292607 245.9393,215.458366 L245.9393,39.5455253 C245.9393,22.8108949 232.292607,9.16420233 215.458366,9.06459144 L39.5455253,9.06459144 C22.8108949,9.16420233 9.16420233,22.8108949 9.06459144,39.5455253 L9.06459144,39.5455253 L9.06459144,39.5455253 Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.688716,154.994553 C189.360311,133.179767 161.270039,179.2 146.129183,189.061479 C135.670039,195.93463 119.732296,196.432685 108.575875,189.957977 C93.3354086,180.992996 98.0171206,159.477043 114.054475,154.197665 C128.398444,149.416342 153.500389,164.557198 162.564981,149.416342 C173.821012,130.789105 135.470817,126.406226 124.115175,126.90428 C103.694942,127.701167 83.9719844,134.375097 71.9190661,149.814786 C58.8700389,166.449805 61.8583658,186.571206 76.2023346,201.712062 C90.8451362,215.856809 112.062257,221.335409 133.279377,219.642023 C138.658366,219.24358 147.822568,216.952529 154.795331,213.067704 C168.740856,205.397665 211.374319,159.377432 207.688716,154.994553 L207.688716,154.994553 L207.688716,154.994553 Z M73.911284,138.757977 C80.9836576,140.152529 67.2373541,100.607004 66.340856,95.1284047 C65.2451362,88.5540856 62.8544747,79.2902724 56.2801556,78.2941634 C48.7097276,77.1984436 46.6178988,85.8645914 48.1120623,93.4350195 C49.9050584,101.204669 67.336965,137.363424 73.911284,138.757977 L73.911284,138.757977 L73.911284,138.757977 Z M132.582101,118.238132 C143.5393,119.831907 142.842023,67.1377432 142.842023,59.9657588 C142.842023,53.4910506 145.332296,35.6607004 136.666148,34.0669261 C124.71284,31.7758755 123.51751,47.5143969 123.318288,55.8817121 C123.716732,64.3486381 121.126848,116.644358 132.582101,118.238132 L132.582101,118.238132 L132.582101,118.238132 Z M158.680156,126.705058 C170.633463,131.685603 179.797665,78.4933852 181.192218,71.7198444 C182.48716,64.7470817 182.785992,50.0046693 170.832685,54.6863813 C164.856031,57.0770428 163.760311,66.7392996 162.863813,72.1182879 C161.36965,78.7922179 149.416342,122.820233 158.680156,126.705058 L158.680156,126.705058 L158.680156,126.705058 Z M101.005447,122.222568 C114.552529,123.218677 101.802335,69.7276265 100.706615,62.555642 C99.6108949,55.2840467 94.7299611,40.740856 84.6692607,49.2077821 C79.5891051,53.4910506 81.8801556,63.3525292 82.8762646,68.9307393 C83.7727626,76.1027237 90.6459144,121.425681 101.005447,122.222568 L101.005447,122.222568 L101.005447,122.222568 Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC5);
export default __webpack_public_path__ + "static/media/c5.8f21f09656189adee9a6290f57ebf2d1.svg";
export { ForwardRef as ReactComponent };